module.exports = __webpack_public_path__ + "static/key-catherineclassic-9bf4db0429ac52ffd398a794e959b3c3.webp";